import React from 'react';

import Map from 'pages/order-confirmation/map';
import { IConfirmationUIProps } from 'pages/order-confirmation/order-confirmation';
import OrderIssues from 'pages/order-confirmation/order-issues';
import { useDeliveryConfirmationContext } from 'state/delivery-confirmation';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import DeliveryDetails from './delivery-details';
import DeliveryDisclaimer from './delivery-disclaimer';
import {
  DeliveryConfirmationRoot,
  FixedMapWindow,
  ScrollContainer,
  StyledOrderIssues,
} from './styled';

const DeliveryConfirmation: React.FC<React.PropsWithChildren<IConfirmationUIProps>> = ({
  serverOrder,
}) => {
  const isShowingOrderingIssue = useFlag(LaunchDarklyFlag.SHOW_ORDERING_ISSUE);

  const { bringgUuids } = useDeliveryConfirmationContext();

  return (
    <DeliveryConfirmationRoot>
      <FixedMapWindow>
        <Map bringgUuids={bringgUuids} serverOrder={serverOrder} />
      </FixedMapWindow>
      <ScrollContainer>
        {serverOrder.delivery && <DeliveryDetails serverOrder={serverOrder} />}
        {isShowingOrderingIssue && (
          <StyledOrderIssues>
            <OrderIssues>
              <DeliveryDisclaimer />
            </OrderIssues>
          </StyledOrderIssues>
        )}
      </ScrollContainer>
    </DeliveryConfirmationRoot>
  );
};

export default DeliveryConfirmation;
